import React, { PureComponent } from "react";
import { Redirect, Link } from "react-router-dom";
import {
    Button,
    Row,
    Col,
    Input,
    Form,
    Alert,
    message,
    Skeleton,
    Space,
    Select,
    Spin,
    Table,
    notification,
    DatePicker,
    Modal,
    Radio
} from "antd";
import "@ant-design/compatible/assets/index.css";

import Config from "../../../Config"

import { connect } from "react-redux";
import { setConfig, ajaxHandler, ajaxViewHandler } from "../../../store/actions";

import "antd/dist/antd.css";
// import TambahKota from "./TambahKota";
// import EditKota from "./EditKota";
import moment from 'moment';
import 'moment/locale/id'; // Impor paket bahasa Indonesia

var configClass = {
    apiUrl: {
        detailPerush: "/api/v1.0/pusat/e-service/kantor-cabang/detail-perusahaan/",
        detail: "/api/v1.0/pusat/e-licensing/detail/",
        detailPerub: "/api/v1.0/pusat/e-licensing/history/",
        endorsement: "/api/v1.0/pusat/e-licensing/endorsement/",
        kapal: "/api/v1.0/pusat/e-licensing/kapal/"
    },
};
class DetailSiupalSiopsus extends PureComponent {
    config;
    timeoutGetQr;
    timeOutPushQr;
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.config = new Config();
        this.state = {
            errMsg: "",
            loadingDetail: false,
            loadingEndors: false,
            loadingPerub: false,
            loadingKapal: false,
            pageKapal: { pageSize: 10 },
            pageEndors: { pageSize: 10 },
            pagePerub: { pageSize: 10 },

            pagination: { pageSize: 10 },
            searchText: "",
            searchColumn: "",
            showDetailError: false,
            dataPerub: [],
            dataEndors: [],
            dataKapal: [],

            namaPerush: "",
            jenis: "",
            status: '',
            nib: "",
            noSiup: "",
            tglSiup: "",
            tglEndors: "",
            alamat: "",
            kota: "",
            propinsi: "",
            npwp: "",
            pj: "",
            alamatPJ: "",
            kodeDB: "",

            columnsEndors: [
                {
                    title: "Tanggal Endorsement",
                    dataIndex: "tgl_endorse",
                    key: "tgl_endorse",
                    render: (text) => moment(text).locale('id').format("DD MMMM YYYY")
                },
                {
                    title: 'Pelaksana',
                    dataIndex: 'PELAKSANA IV',
                    key: 'PELAKSANA IV',
                },
                {
                    title: 'Kasi Subdit',
                    dataIndex: 'KASI IV',
                    key: 'KASI IV',
                },
                {
                    title: 'Kasubdit',
                    dataIndex: 'KASUBDIT IV',
                    key: 'KASUBDIT IV',
                },
            ],
            columnsKapal: [
                {
                    title: "Nama",
                    dataIndex: "nama_kapal",
                    key: "nama_kapal",
                },
                {
                    title: "Status",
                    dataIndex: "status_kapal",
                    key: "status_kapal",
                },
                {
                    title: "Bendera",
                    dataIndex: "kode_bendera",
                    key: "kode_bendera",
                },
                {
                    title: "TPK",
                    dataIndex: "tpk",
                    key: "tpk",
                },
                {
                    title: "DWT",
                    dataIndex: "dwt",
                    key: "dwt",
                },
                {
                    title: "GT",
                    dataIndex: "gt",
                    key: "gt",
                },
                {
                    title: "HT",
                    dataIndex: "hp",
                    key: "hp",
                },
                {
                    title: "NT",
                    dataIndex: "nt",
                    key: "nt",
                },
                {
                    title: "Tipe",
                    dataIndex: "tipe",
                    key: "tipe",
                },
                {
                    title: "Tahun Buat",
                    dataIndex: "tahun_buat",
                    key: "tahun_buat",
                },
                {
                    title: "Masa Berlaku",
                    dataIndex: "masa_berlaku",
                    key: "masa_berlaku",
                    render: (text) => moment(text).locale('id').format("DD MMMM YYYY")
                },
            ],

            columnsPerubahan: [
                {
                    title: "Alamat Lama",
                    dataIndex: "alamat_lama",
                    key: "alamat_lama",
                },
                {
                    title: "Alamat Baru",
                    dataIndex: "alamat_baru",
                    key: "alamat_baru",
                },
                {
                    title: "NPWP Lama",
                    dataIndex: "npwp_lama",
                    key: "npwp_lama",
                },
                {
                    title: "NPWP Baru",
                    dataIndex: "npwp_baru",
                    key: "npwp_baru",
                },
                {
                    title: "Nama PJ Lama",
                    dataIndex: "namapenanggungjawab_lama",
                    key: "namapenanggungjawab_lama",
                },
                {
                    title: "Nama PJ Baru",
                    dataIndex: "namapenanggungjawab_baru",
                    key: "namapenanggungjawab_baru",
                },
                {
                    title: "Alamat PJ Lama",
                    dataIndex: "alamatpenanggungjawab_lama",
                    key: "alamatpenanggungjawab_lama",
                },
                {
                    title: "Alamat PJ Baru",
                    dataIndex: "alamatpenanggungjawab_baru",
                    key: "alamatpenanggungjawab_baru",
                },
                {
                    title: "Status Perusahaan Lama",
                    dataIndex: "status_perus_lama",
                    key: "status_perus_lama",
                },
                {
                    title: "Status Perusahaan Baru",
                    dataIndex: "status_perus_baru",
                    key: "status_perus_baru",
                },
                {
                    title: "Kwn Lama",
                    dataIndex: "kewarganegaraan_lama",
                    key: "kewarganegaraan_lama",
                },
                {
                    title: "Kwn Baru",
                    dataIndex: "kewarganegaraan_baru",
                    key: "kewarganegaraan_baru",
                },
                {
                    title: "No Ktp PJ Lama",
                    dataIndex: "ktppenanggungjawab_lama",
                    key: "ktppenanggungjawab_lama",
                },
                {
                    title: "No Ktp PJ Baru",
                    dataIndex: "ktppenanggungjawab_baru",
                    key: "ktppenanggungjawab_baru",
                },
                {
                    title: "Masa Berlaku Kitas Lama",
                    dataIndex: "masa_berlaku_kitas_lama",
                    key: "masa_berlaku_kitas_lama",
                    render: (text) => moment(text).locale('id').format("DD MMMM YYYY")
                },
                {
                    title: "Masa Berlaku Kitas Baru",
                    dataIndex: "masa_berlaku_kitas_baru",
                    key: "masa_berlaku_kitas_baru",
                    render: (text) => moment(text).locale('id').format("DD MMMM YYYY")
                },
                {
                    title: "Masa Berlaku Imta Lama",
                    dataIndex: "masa_berlaku_imta_lama",
                    key: "masa_berlaku_imta_lama",
                    render: (text) => moment(text).locale('id').format("DD MMMM YYYY")
                },
                {
                    title: "Masa Berlaku Imta Baru",
                    dataIndex: "masa_berlaku_imta_baru",
                    key: "masa_berlaku_imta_baru",
                    render: (text) => moment(text).locale('id').format("DD MMMM YYYY")
                },
            ],
        };
    }


    UNSAFE_componentWillMount() { }

    async componentDidMount() { }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.getDataDetail();
            this.getDataPerubahan();
            this.getDataKapal();
            this.getDataEndors();

        }
    }

    removeTab = targetKey => {
        // console.log("masuk sini")
        var tempTabs = this.props.tabs;
        const index_cari = tempTabs.findIndex((data) => data.key == targetKey);
        var activeKey = "";
        if (index_cari != -1) {
            activeKey = tempTabs[index_cari - 1].key
            tempTabs.splice(index_cari, 1);
        }
        // alert(activeKey);
        this.props.setConfig({
            tabs: tempTabs,
            activeKey: activeKey
        });
    };

    tabProses(tabData) {
        const key = tabData.key;
        var tempTabs = this.props.tabs;
        var isExist = false;
        tempTabs.map((item) => {
            if (item.key == key) {
                isExist = true;
            }
        });
        if (isExist) {
            this.props.setConfig({
                activeKey: tabData.key,
            });
        } else {
            tempTabs = [
                ...tempTabs,
                {
                    title: tabData.title,
                    content: tabData.content,
                    key: tabData.key,
                },
            ];
            this.props.setConfig({
                tabs: tempTabs,
                activeKey: tabData.key,
            });
        }
    }

    async getDataPerubahan(limit = this.state.pagePerub.pageSize, offset = 1) {
        this.setState({
            loadingPerub: true,
            errTitle: "",
            errMsg: "",
            showDetailError: false,
            dataPerub: []
        });
        // console.log("getDataPerubahan", configClass.apiUrl.detailPerub + this.props.id + "?limit=" +
        //     limit + "&page=" + offset)

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.detailPerub + this.props.id + "?limit=" +
                limit + "&page=" + offset)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    const pagePerub = { ...this.state.pagePerub };
                    pagePerub.total = data.responseData.attributes.total;
                    var dataItem = data.responseData.items;
                    this.setState({
                        dataPerub: dataItem,
                        pagePerub,
                    });
                    // console.log("getData", this.state.dataPerub);

                } else {
                    const errTitle = "failed get data";
                    const err = this.props.responseMsg.responseMessage ? this.props.responseMsg.responseMessage : this.props.responseMsg;
                    notification.error({
                        message: errTitle,
                        description: JSON.stringify(err),
                        placement: "bottomRight",
                    });
                }

                this.setState({ loadingPerub: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                notification.error({
                    message: "gagal_get_preview",
                    description: JSON.stringify(response),
                    placement: "bottomRight",
                });
                this.setState({ loadingPerub: false });
            });
    }

    async getDataPerush() {
        this.setState({
            loadingPerush: true,
        });
        // console.log("getDataPerush", configClass.apiUrl.detailPerush + this.props.id)
        this.props
            .ajaxViewHandler("get", configClass.apiUrl.detailPerush + this.props.id)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    var dataItem = data.responseData.items;
                    this.setState({
                        namaPerush: dataItem[0].nama_perusahaan,
                        alamatPerush: dataItem[0].alamat,
                        noSiup: dataItem[0].no_siup,
                        tglSiup: moment(dataItem[0].tgl_siup).locale('id').format("DD MMMM YYYY")
                    });
                    // console.log("getDataPerush", dataItem);

                } else {
                    const errTitle = "failed get data";
                    const err = this.props.responseMsg.responseMessage ? this.props.responseMsg.responseMessage : this.props.responseMsg;
                    notification.error({
                        message: errTitle,
                        description: JSON.stringify(err),
                        placement: "bottomRight",
                    });
                }
                this.setState({ loadingPerush: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                notification.error({
                    message: "gagal_get_preview",
                    description: JSON.stringify(response),
                    placement: "bottomRight",
                });
                this.setState({ loadingPerush: false });
            });
    }

    async getDataDetail() {
        this.setState({
            loadingKantor: true,
        });

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.detail + this.props.id)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    var dataItem = data.responseData.items;
                    this.setState({
                        namaPerush: dataItem[0].pr_nama,
                        jenis: dataItem[0].jenis,
                        status: dataItem[0].status,
                        nib: dataItem[0].pr_nib,
                        noSiup: dataItem[0].no_siup,
                        tglSiup: moment(dataItem[0].tgl_siup).locale('id').format("DD MMMM YYYY"),
                        tglEndors: moment(dataItem[0].tgl_endorse).locale('id').format("DD MMMM YYYY"),
                        alamat: dataItem[0].pr_alamat,
                        kota: dataItem[0].kota,
                        propinsi: dataItem[0].prop_nama,
                        npwp: dataItem[0].pr_npwp,
                        pj: dataItem[0].pr_namapenanggungjawab,
                        alamatPJ: dataItem[0].pr_alamatpenanggungjawab,
                    });
                    // console.log("getDataKantor", dataItem);

                } else {
                    const errTitle = "failed get data";
                    const err = this.props.responseMsg.responseMessage ? this.props.responseMsg.responseMessage : this.props.responseMsg;
                    notification.error({
                        message: errTitle,
                        description: JSON.stringify(err),
                        placement: "bottomRight",
                    });
                }
                this.setState({ loadingKantor: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                notification.error({
                    message: "gagal_get_preview",
                    description: JSON.stringify(response),
                    placement: "bottomRight",
                });
                this.setState({ loadingKantor: false });
            });
    }

    async getDataKapal(limit = this.state.pageKapal.pageSize, offset = 1) {
        this.setState({
            loadingKapal: true,
            errTitle: "",
            errMsg: "",
            showDetailError: false,
            dataKapal: []
        });
        // console.log("getDataKapal", configClass.apiUrl.kapal + this.props.id + "?limit=" +
        //     limit + "&page=" + offset);

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.kapal + this.props.id + "?limit=" +
                limit + "&page=" + offset)

            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    const pageKapal = { ...this.state.pageKapal };
                    pageKapal.total = data.responseData.attributes.total;
                    var dataItem = data.responseData.items;
                    this.setState({
                        dataKapal: dataItem,
                        pageKapal,
                    });
                    // console.log("getData", this.state.dataPerub);

                } else {
                    const errTitle = "failed get data";
                    const err = this.props.responseMsg.responseMessage ? this.props.responseMsg.responseMessage : this.props.responseMsg;
                    notification.error({
                        message: errTitle,
                        description: JSON.stringify(err),
                        placement: "bottomRight",
                    });
                }

                this.setState({ loadingKapal: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                notification.error({
                    message: "gagal_get_preview",
                    description: JSON.stringify(response),
                    placement: "bottomRight",
                });
                this.setState({ loadingKapal: false });
            });
    }


    async getDataEndors(limit = this.state.pageEndors.pageSize, offset = 1) {
        this.setState({
            loadingEndors: true,
            errTitle: "",
            errMsg: "",
            showDetailError: false,
            dataKapal: []
        });
        // console.log(stateName, url);

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.endorsement + this.props.id + "?limit=" +
                limit + "&page=" + offset)
            .then(() => {
                const data = this.props.responseMsg;
                // console.log("getDataEndors data", data);
                if (this.props.isSuccess) {
                    const pageEndors = { ...this.state.pageEndors };
                    pageEndors.total = data.responseData.attributes.total;
                    var dataItem = data.responseData.items;
                    const dataSource = dataItem.map(item => {
                        const rowData = {
                            tgl_endorse: item.tgl_endorse,
                        };

                        item.approval.forEach(approval => {
                            const { evaluator, created_by } = approval;
                            rowData[evaluator] = evaluator;
                        });

                        return rowData;
                    });

                    // const dataSource = dataItem.flatMap(item => {
                    //     return item.approval.map(approval => ({
                    //         tgl_endorse: item.tgl_endorse,
                    //         created_by: approval.created_by,
                    //         evaluator: approval.evaluator,
                    //         bpm_status: approval.bpm_status,
                    //         tgl_approval: approval.tgl_approval,
                    //     }));
                    // });
                    // console.log("getDataEndors", dataSource);
                    
                    this.setState({
                        dataEndors: dataSource,
                        pageEndors,
                    });

                } else {
                    const errTitle = "failed get data";
                    const err = this.props.responseMsg.responseMessage ? this.props.responseMsg.responseMessage : this.props.responseMsg;
                    notification.error({
                        message: errTitle,
                        description: JSON.stringify(err),
                        placement: "bottomRight",
                    });
                }

                this.setState({ loadingEndors: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                notification.error({
                    message: "gagal_get_preview",
                    description: JSON.stringify(response),
                    placement: "bottomRight",
                });
                this.setState({ loadingEndors: false });
            });
    }
    // filterData(values) {
    //     var filter = "";
    //     for (var key in values) {
    //         if (values[key] != undefined) {
    //             filter += "&" + key + "=" + values[key];
    //         }
    //     }
    //     console.log("filter", filter)

    //     this.setState({
    //         filter: filter,
    //         pagination: { pageSize: 10, current: 1 },
    //     }, () => {
    //         this.getData(this.state.pagination.pageSize, 1)
    //     });
    // }

    handleTableChange = async (pagination, filters, sorter) => {
        const newPagination = { ...this.state.pageEndors };
        newPagination.pageSize = pagination.pageSize;
        this.setState({
            loadingEndors: true,
            pagination,
        });
        if (pagination.current == 1) {
            this.getDataEndors(pagination.pageSize);
        } else {
            this.getDataEndors(
                pagination.pageSize,
                pagination.current
                // (pagination.current - 1) * pagination.pageSize
            );
        }
    };

    handleTableChangePerub = async (pagination, filters, sorter) => {
        const newPagination = { ...this.state.pagePerub };
        newPagination.pageSize = pagination.pageSize;
        this.setState({
            loadingPerub: true,
            pagination,
        });
        if (pagination.current == 1) {
            this.getDataPerubahan(pagination.pageSize);
        } else {
            this.getDataPerubahan(
                pagination.pageSize,
                pagination.current
                // (pagination.current - 1) * pagination.pageSize
            );
        }
    };

    
    handleTableChangeKapal = async (pagination, filters, sorter) => {
        const newPagination = { ...this.state.pageKapal };
        newPagination.pageSize = pagination.pageSize;
        this.setState({
            loadingKapal: true,
            pagination,
        });
        if (pagination.current == 1) {
            this.getDataKapal(pagination.pageSize);
        } else {
            this.getDataKapal(
                pagination.pageSize,
                pagination.current
                // (pagination.current - 1) * pagination.pageSize
            );
        }
    };
    // handleClear() {
    //     this.setState({
    //         filter: ""
    //     }, () => {
    //         this.formRef.current.resetFields();
    //         this.getData(this.state.pagination.pageSize, 1);
    //     });
    // }

    render() {
        return (
            <>
                <style>
                    {`
                    .data-row:nth-child(odd) {background-color: #f5f5f5;}
                    .label-with-spacing {margin-left: 8px;}
                    `}
                </style>
                {/*<!-- Tab Content -->*/}
                <div className="row tab-content">
                    {/*<!-- Tab Beranda -->*/}
                    <div className="col-12">
                        <Spin
                            size="large"
                            spinning={this.state.loadingKantor}
                            tip={<span style={{ color: "#000" }}>loading...</span>}
                        >
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-tittle">DETAIL SIUPAL / SIOPSUS</h4>
                                            <a className="heading-elements-toggle">
                                                <i className="la la-ellipsis-v font-medium-3"></i>
                                            </a>
                                            <div className="heading-elements">
                                                <ul className="list-inline mb-0">
                                                    <li>
                                                        <a data-action="expand">
                                                            <i className="ft-maximize"></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a data-action="collapse">
                                                            <i className="ft-plus"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="card-content collapse show">
                                            <div className="card-body">
                                                <div className="form-body">
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nama Perusahaan</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.namaPerush}</label></Col>
                                                    </Row>

                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Jenis/Status</label></Col>
                                                        {(this.state.jenis != '' &&
                                                            <Col span={16}><label className="col-md-12 label-control">: {this.state.jenis} <b>({this.state.status ? this.state.status : 'Tidak Aktif'})</b></label></Col>
                                                        )}
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nomor Induk Berusaha</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.nib}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">No. SIUP</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.noSiup}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Tanggal SIUP </label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.tglSiup}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Tanggal Endorse</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.tglEndors}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Alamat Domisili</label></Col>
                                                        {(this.state.alamat != '' &&
                                                            <Col span={16}>
                                                                <label className="col-md-12 label-control">: {this.state.alamat}</label>
                                                                <label className="col-md-12 label-control label-with-spacing">Kota {this.state.kota}</label>
                                                                <label className="col-md-12 label-control label-with-spacing">Propinsi {this.state.propinsi}</label>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">NPWP Perusahaan</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.npwp}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Penanggung Jawab </label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.pj}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Alamat Penanggung Jawab  </label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.alamatPJ}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Kode DB</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kodeDB}</label></Col>
                                                    </Row>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Spin>
                    </div>
                    <div className="col-12" id="berkas">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-tittle">ENDORSEMENT PERUSAHAAN</h4>
                                    </div>
                                    <div className="card-content collapse show">
                                        <div className="card-body">
                                            {(this.state.errMsg != null && this.state.errMsg != "" &&
                                                <Alert
                                                    message={this.state.errTitle}
                                                    description={
                                                        <div>
                                                            {this.state.showDetailError == true
                                                                ?
                                                                JSON.stringify(this.state.errMsg)
                                                                :
                                                                "gagal mendapatkan response server, cobalah beberapa saat lagi"
                                                            }
                                                        </div>
                                                    }
                                                    // description={JSON.stringify(this.state.errMsg)}
                                                    type="error"
                                                    showIcon
                                                    closable
                                                    style={{
                                                        marginBottom: 10,
                                                    }}
                                                    action={
                                                        <Space direction="vertical">
                                                            <Button size="small" type="primary" onClick={() => this.getData(this.state.pagination.pageSize, 1)}>
                                                                Try Again
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                danger
                                                                type="ghost"
                                                                onClick={() => {
                                                                    const recentValue = this.state.showDetailError;
                                                                    this.setState({
                                                                        showDetailError: !recentValue
                                                                    })
                                                                }}
                                                            >
                                                                {this.state.showDetailError == true ? "Hide Error Detail" : "Show Error Detail"}
                                                            </Button>
                                                        </Space>
                                                    }
                                                />
                                            )}
                                            <div className="table-responsive">
                                                <Table
                                                    // style={{margin: 10}}
                                                    title={() => (
                                                        <Row>
                                                            <Col lg={8} sm={24} xs={24}>
                                                                <span className="konten-judul">
                                                                    Total {this.state.pageEndors.total} record
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    rowKey="tgl_approval"
                                                    bordered
                                                    columns={this.state.columnsEndors}
                                                    dataSource={this.state.dataEndors}
                                                    loading={this.state.loadingEndors}
                                                    // scroll={{ x: 500, y: 600 }}
                                                    size="small"
                                                    pagination={this.state.pageEndors}
                                                    onChange={this.handleTableChange}
                                                    className="table table-bordered table-striped mb-0"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<!-- end berkas -->*/}
                    </div>
                    <div className="col-12" id="berkas">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-tittle">PERUBAHAN DATA PERUSAHAAN</h4>
                                    </div>
                                    <div className="card-content collapse show">
                                        <div className="card-body">
                                            {(this.state.errMsg != null && this.state.errMsg != "" &&
                                                <Alert
                                                    message={this.state.errTitle}
                                                    description={
                                                        <div>
                                                            {this.state.showDetailError == true
                                                                ?
                                                                JSON.stringify(this.state.errMsg)
                                                                :
                                                                "gagal mendapatkan response server, cobalah beberapa saat lagi"
                                                            }
                                                        </div>
                                                    }
                                                    // description={JSON.stringify(this.state.errMsg)}
                                                    type="error"
                                                    showIcon
                                                    closable
                                                    style={{
                                                        marginBottom: 10,
                                                    }}
                                                    action={
                                                        <Space direction="vertical">
                                                            <Button size="small" type="primary" onClick={() => this.getData(this.state.pagination.pageSize, 1)}>
                                                                Try Again
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                danger
                                                                type="ghost"
                                                                onClick={() => {
                                                                    const recentValue = this.state.showDetailError;
                                                                    this.setState({
                                                                        showDetailError: !recentValue
                                                                    })
                                                                }}
                                                            >
                                                                {this.state.showDetailError == true ? "Hide Error Detail" : "Show Error Detail"}
                                                            </Button>
                                                        </Space>
                                                    }
                                                />
                                            )}
                                            <div className="table-responsive">
                                                <Table
                                                    // style={{margin: 10}}
                                                    title={() => (
                                                        <Row>
                                                            <Col lg={8} sm={24} xs={24}>
                                                                <span className="konten-judul">
                                                                    Total {this.state.pagination.total} record
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    rowKey="npwp_lama"
                                                    bordered
                                                    columns={this.state.columnsPerubahan}
                                                    dataSource={this.state.dataPerub}
                                                    loading={this.state.loadingPerub}
                                                    // scroll={{ x: 500, y: 600 }}
                                                    size="small"
                                                    pagination={this.state.pagePerub}
                                                    onChange={this.handleTableChangePerub}
                                                    className="table table-bordered table-striped mb-0"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<!-- end berkas -->*/}
                    </div>
                    <div className="col-12" id="berkas">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-tittle">KAPAL MILIK</h4>
                                    </div>
                                    <div className="card-content collapse show">
                                        <div className="card-body">
                                            {(this.state.errMsg != null && this.state.errMsg != "" &&
                                                <Alert
                                                    message={this.state.errTitle}
                                                    description={
                                                        <div>
                                                            {this.state.showDetailError == true
                                                                ?
                                                                JSON.stringify(this.state.errMsg)
                                                                :
                                                                "gagal mendapatkan response server, cobalah beberapa saat lagi"
                                                            }
                                                        </div>
                                                    }
                                                    // description={JSON.stringify(this.state.errMsg)}
                                                    type="error"
                                                    showIcon
                                                    closable
                                                    style={{
                                                        marginBottom: 10,
                                                    }}
                                                    action={
                                                        <Space direction="vertical">
                                                            <Button size="small" type="primary" onClick={() => this.getData(this.state.pagination.pageSize, 1)}>
                                                                Try Again
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                danger
                                                                type="ghost"
                                                                onClick={() => {
                                                                    const recentValue = this.state.showDetailError;
                                                                    this.setState({
                                                                        showDetailError: !recentValue
                                                                    })
                                                                }}
                                                            >
                                                                {this.state.showDetailError == true ? "Hide Error Detail" : "Show Error Detail"}
                                                            </Button>
                                                        </Space>
                                                    }
                                                />
                                            )}
                                            <div className="table-responsive">
                                                <Table
                                                    // style={{margin: 10}}
                                                    title={() => (
                                                        <Row>
                                                            <Col lg={8} sm={24} xs={24}>
                                                                <span className="konten-judul">
                                                                    Total {this.state.pageKapal.total} record
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    rowKey="tpk"
                                                    bordered
                                                    columns={this.state.columnsKapal}
                                                    dataSource={this.state.dataKapal}
                                                    loading={this.state.loadingKapal}
                                                    // scroll={{ x: 500, y: 600 }}
                                                    size="small"
                                                    pagination={this.state.pageKapal}
                                                    onChange={this.handleTableChangeKapal}
                                                    className="table table-bordered table-striped mb-0"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<!-- end berkas -->*/}
                    </div>

                    {/*<!-- End Tab Beranda -->*/}
                </div >
                {/*<!-- End Tab Beranda -->*/}
            </>
        );
    }
}

const mapStateToProps = function (state) {
    return state.configReducers;
};

export default connect(mapStateToProps, {
    setConfig,
    ajaxHandler,
    ajaxViewHandler,
})(DetailSiupalSiopsus);
